import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (!data.mfa_required) setUser(data);
    return data;
  };

  const loginMfa = async (mfa_token, code, trust) => {
    const { data } = await api.post("/auth/login/mfa", { mfa_token, code, trust });
    setUser(data);
    return data;
  };

  const requestCode = (email) => api.post("/auth/code/request", { email });

  const loginWithCode = async (email, code) => {
    const { data } = await api.post("/auth/code/verify", { email, code });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginMfa, requestCode, loginWithCode, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
